/* eslint-disable */
/* tslint:disable */
/* prettier-ignore */
interface TrackOptionsBase {
  sendUserIfExists: boolean
}

interface TrackLiteOptions extends TrackOptionsBase {
  lite: true
  sendInstance: boolean
  sendUser: boolean
  sendUserIfExists: boolean
  sendBrowser: boolean
}

export type TrackOptions =
  | ({ lite: false } & TrackOptionsBase)
  | TrackLiteOptions

export class GnarSpec {

  constructor(private gnar: { track(props: { eventName: string, [k: string]: any }, options?: TrackOptions): Promise<void> }) {}

  /**
   * Tracks clicks on Extension Install CTAs. Base events for button-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  addExtensionButtonClick(
    pageId: string,
    pageSlug: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/addExtension-button-click',
      object: 'button',
      objectId: 'addExtension',
      pageId,
      pageSlug,
      placement,
      placementInternalName
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  aiDetectorCtaClick(
    ctaType: 'clear' | 'paywallClose',
    pageId: string,
    pageSlug: string,
    placement: 'paywall' | 'textArea'
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/aiDetectorCta-click',
      objectId: 'aiDetectorCta',
      ctaType,
      pageId,
      pageSlug,
      placement
    })
  }

  /**
   * Tracks when a user submits the form.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  aiDetectorFormSubmit(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'submit',
      eventName: 'cms/aiDetectorForm-submit',
      objectId: 'aiDetectorForm',
      pageId,
      pageSlug
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  aiDetectorGenerateFailure(
    pageId: string,
    pageSlug: string,
    error?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'failure',
      eventName: 'cms/aiDetectorGenerate-failure',
      objectId: 'aiDetectorGenerate',
      pageId,
      pageSlug,
      error
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  aiDetectorGenerateSuccess(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'success',
      eventName: 'cms/aiDetectorGenerate-success',
      objectId: 'aiDetectorGenerate',
      pageId,
      pageSlug
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  aiDetectorHighlightedTextClick(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/aiDetectorHighlightedText-click',
      objectId: 'aiDetectorHighlightedText',
      pageId,
      pageSlug
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  aiDetectorIntoolSignupWallShow(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/aiDetectorIntoolSignupWall-show',
      objectId: 'aiDetectorIntoolSignupWall',
      pageId,
      pageSlug
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  aiDetectorWallShow(
    pageId: string,
    pageSlug: string,
    wallType: 'textLimit' | 'usage'
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/aiDetectorWall-show',
      objectId: 'aiDetectorWall',
      pageId,
      pageSlug,
      wallType
    })
  }

  /**
   * Tracks clicks on interactive animation Lottie components Base events for non-button
   * clickable element events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param segmentIndex - Index of the segment clicked, if the animation is
   *                       interactive, helps us to understand user engagement with
   *                       animation
   * @param meta - Additional metadata about the event
   * @param placement - Component the element is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  animationInteractiveElementClick(
    pageId: string,
    pageSlug: string,
    segmentIndex: number,
    meta?: string,
    placement?: string,
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/animation-interactiveElement-click',
      object: 'interactiveElement',
      objectId: 'animation',
      pageId,
      pageSlug,
      segmentIndex,
      meta,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks when interactive animation finishes playing Base events for non-button clickable
   * element events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the element is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  animationInteractiveElementFinish(
    pageId: string,
    pageSlug: string,
    placement?: string,
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'finish',
      eventName: 'cms/animation-interactiveElement-finish',
      object: 'interactiveElement',
      objectId: 'animation',
      pageId,
      pageSlug,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks clicks on replay button on interactive animation Lottie components Base events for
   * non-button clickable element events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the element is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  animationInteractiveElementReplay(
    pageId: string,
    pageSlug: string,
    placement?: string,
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'replay',
      eventName: 'cms/animation-interactiveElement-replay',
      object: 'interactiveElement',
      objectId: 'animation',
      pageId,
      pageSlug,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks when Lottie interactive animations are rendered Base events for non-button
   * clickable element events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param meta - Additional metadata about the event
   * @param placement - Component the element is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  animationInteractiveElementShow(
    pageId: string,
    pageSlug: string,
    meta?: string,
    placement?: string,
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/animation-interactiveElement-show',
      object: 'interactiveElement',
      objectId: 'animation',
      pageId,
      pageSlug,
      meta,
      placement,
      placementInternalName
    })
  }

  /**
   * Fires when the banner is clicked. Base event for banner-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param ctaUrl - cta URL
   */
  bannerClick(
    internalName: string,
    pageId: string,
    pageSlug: string,
    ctaUrl?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/banner-click',
      object: 'banner',
      internalName,
      pageId,
      pageSlug,
      ctaUrl
    })
  }

  /**
   * Fires when the banner is shown. Base event for banner-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param ctaUrl - cta URL
   */
  bannerShow(
    internalName: string,
    pageId: string,
    pageSlug: string,
    ctaUrl?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/banner-show',
      object: 'banner',
      internalName,
      pageId,
      pageSlug,
      ctaUrl
    })
  }

  /**
   * Fires when form text check submit fails. Check "errorMessage" prop for details on the fail
   * reason.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param formErrorMessage - Shows error related to text checker form submission.
   */
  checkTextFormFormFail(
    pageId: string,
    pageSlug: string,
    formErrorMessage?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'fail',
      eventName: 'cms/checkTextForm-form-fail',
      object: 'form',
      objectId: 'checkTextForm',
      pageId,
      pageSlug,
      formErrorMessage
    })
  }

  /**
   * Fires when the text checker form is submitted successfully.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  checkTextFormFormSuccess(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'success',
      eventName: 'cms/checkTextForm-form-success',
      object: 'form',
      objectId: 'checkTextForm',
      pageId,
      pageSlug
    })
  }

  /**
   * Fires when the not enough text popup is shown on text checker.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param wordCount - Shows how many words are in the text that user chose to
   *                    check before seeing the popup.
   */
  checkTextNotEnoughTextPopupShow(
    pageId: string,
    pageSlug: string,
    wordCount: number
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/checkTextNotEnoughText-popup-show',
      object: 'popup',
      objectId: 'checkTextNotEnoughText',
      pageId,
      pageSlug,
      wordCount
    })
  }

  /**
   * Tracks pastes in text checker editor.
   * @param characterCount - Shows how many characters are in the text that user chose to
   *                         paste.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param wordCount - Shows how many words are in the text that user chose to
   *                    paste.
   * @param isOverLimit - Determines if the pasted text goes over the text limit
   */
  checkTextPastePaste(
    characterCount: number,
    pageId: string,
    pageSlug: string,
    wordCount: number,
    isOverLimit?: boolean
  ): Promise<void> {
    return this.gnar.track({
      action: 'paste',
      eventName: 'cms/checkTextPaste-paste',
      objectId: 'checkTextPaste',
      characterCount,
      pageId,
      pageSlug,
      wordCount,
      isOverLimit
    })
  }

  /**
   * Fires when the user chooses to use the sample text using the link. Base events for
   * button-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  checkTextSampleTextLinkClick(
    pageId: string,
    pageSlug: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/checkTextSampleText-link-click',
      object: 'link',
      objectId: 'checkTextSampleText',
      pageId,
      pageSlug,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks clicks on check text CTAs on text checker components. Base events for
   * button-related events
   * @param characterCount - Shows how many characters are in the text that user chose to
   *                         check.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param wordCount - Shows how many words are in the text that user chose to
   *                    check.
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  checkTextSubmitButtonClick(
    characterCount: number,
    pageId: string,
    pageSlug: string,
    wordCount: number,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/checkTextSubmit-button-click',
      object: 'button',
      objectId: 'checkTextSubmit',
      characterCount,
      pageId,
      pageSlug,
      wordCount,
      placement,
      placementInternalName
    })
  }

  /**
   * Fires when the intool sign up wall is closed. Base events for button-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  cmsIntoolSignupWallCloseButtonClick(
    pageId: string,
    pageSlug: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/cmsIntoolSignupWallClose-button-click',
      object: 'button',
      objectId: 'cmsIntoolSignupWallClose',
      pageId,
      pageSlug,
      placement,
      placementInternalName
    })
  }

  /**
   * Personalization variation show event
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param personalizationType - Internal name of variation container
   * @param variation - Internal name of variation component
   */
  cmsPersonalizedContentComponentShow(
    pageId: string,
    pageSlug: string,
    personalizationType: string,
    variation: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/cmsPersonalizedContent-component-show',
      object: 'component',
      objectId: 'cmsPersonalizedContent',
      pageId,
      pageSlug,
      personalizationType,
      variation
    })
  }

  /**
   * Tracks clicks on Link CTAs. Base events for button-related events
   * @param internalName - Internal name of the Link in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param targetUrl - Target URL
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  customLinkCtaButtonClick(
    internalName: string,
    pageId: string,
    pageSlug: string,
    targetUrl: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/customLinkCta-button-click',
      object: 'button',
      objectId: 'customLinkCta',
      internalName,
      pageId,
      pageSlug,
      targetUrl,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks click on a Footer item
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  footerItemClick(
    label: string,
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/footer-item-click',
      object: 'item',
      objectId: 'footer',
      label,
      pageId,
      pageSlug
    })
  }

  /**
   * Fires when form submit fails. Check "errorMessage" prop for details on the fail reason.
   * Base event for form-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param submitUrl - Submit URL
   * @param formErrorMessage - Shows error related to the whole form (irrespective of
   *                           particular field).
   */
  formFail(
    internalName: string,
    pageId: string,
    pageSlug: string,
    submitUrl: string,
    formErrorMessage?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'fail',
      eventName: 'cms/form-fail',
      object: 'form',
      internalName,
      pageId,
      pageSlug,
      submitUrl,
      formErrorMessage
    })
  }

  /**
   * Fires when the form is prefilled successfully. Base event for form-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param prefilledFieldNames - Successfully prefilled field names.
   * @param submitUrl - Submit URL
   */
  formPrefillSuccess(
    internalName: string,
    pageId: string,
    pageSlug: string,
    prefilledFieldNames: Array<string>,
    submitUrl: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'prefillSuccess',
      eventName: 'cms/form-prefillSuccess',
      object: 'form',
      internalName,
      pageId,
      pageSlug,
      prefilledFieldNames,
      submitUrl
    })
  }

  /**
   * Fires when the recaptcha response is Fail Base event for form-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param submitUrl - Submit URL
   */
  formRecaptchaFail(
    internalName: string,
    pageId: string,
    pageSlug: string,
    submitUrl: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'recaptchaFail',
      eventName: 'cms/form-recaptchaFail',
      object: 'form',
      internalName,
      pageId,
      pageSlug,
      submitUrl
    })
  }

  /**
   * Fires when the recaptcha response is OK Base event for form-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param submitUrl - Submit URL
   */
  formRecaptchaSuccess(
    internalName: string,
    pageId: string,
    pageSlug: string,
    submitUrl: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'recaptchaSuccess',
      eventName: 'cms/form-recaptchaSuccess',
      object: 'form',
      internalName,
      pageId,
      pageSlug,
      submitUrl
    })
  }

  /**
   * Fires when the form is submitted. Base event for form-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param submitUrl - Submit URL
   */
  formSubmit(
    internalName: string,
    pageId: string,
    pageSlug: string,
    submitUrl: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'submit',
      eventName: 'cms/form-submit',
      object: 'form',
      internalName,
      pageId,
      pageSlug,
      submitUrl
    })
  }

  /**
   * Fires when the form is submitted successfully. Base event for form-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param submitUrl - Submit URL
   */
  formSuccess(
    internalName: string,
    pageId: string,
    pageSlug: string,
    submitUrl: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'success',
      eventName: 'cms/form-success',
      object: 'form',
      internalName,
      pageId,
      pageSlug,
      submitUrl
    })
  }

  /**
   * Fires when webinar creation fails. Check "webinarErrorMessage" prop for details on the
   * fail reason. Base event for form-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param submitUrl - Submit URL
   * @param webinarErrorMessage - Error message of webinar creation failure.
   * @param webinarId - Id of the webinar to create.
   */
  formWebinarFail(
    internalName: string,
    pageId: string,
    pageSlug: string,
    submitUrl: string,
    webinarErrorMessage: string,
    webinarId: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'webinarFail',
      eventName: 'cms/form-webinarFail',
      object: 'form',
      internalName,
      pageId,
      pageSlug,
      submitUrl,
      webinarErrorMessage,
      webinarId
    })
  }

  /**
   * Fires when the webinar has been created successfully. Base event for form-related events
   * @param internalName - Internal name of the Form in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param submitUrl - Submit URL
   * @param webinarId - Id of the webinar to create.
   */
  formWebinarSuccess(
    internalName: string,
    pageId: string,
    pageSlug: string,
    submitUrl: string,
    webinarId: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'webinarSuccess',
      eventName: 'cms/form-webinarSuccess',
      object: 'form',
      internalName,
      pageId,
      pageSlug,
      submitUrl,
      webinarId
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsCtaClick(
    ctaType: 'copy' | 'sampleText',
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/goToolsCta-click',
      objectId: 'goToolsCta',
      ctaType,
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks when a user encounters an error at any step in the form
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsFormError(
    activeStep: number,
    error: string,
    inputName: string,
    inputType: 'file upload' | 'long text' | 'short text',
    pageId: string,
    pageSlug: string,
    totalSteps: number
  ): Promise<void> {
    return this.gnar.track({
      action: 'error',
      eventName: 'cms/goToolsForm-error',
      objectId: 'goToolsForm',
      activeStep,
      error,
      inputName,
      inputType,
      pageId,
      pageSlug,
      totalSteps
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsFormInputInteraction(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'interaction',
      eventName: 'cms/goToolsFormInput-interaction',
      objectId: 'goToolsFormInput',
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks when a user clicks 'Back' at any step in the form
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsFormStepBack(
    activeStep: number,
    inputName: string,
    inputType: 'file upload' | 'long text' | 'short text',
    pageId: string,
    pageSlug: string,
    totalSteps: number
  ): Promise<void> {
    return this.gnar.track({
      action: 'back',
      eventName: 'cms/goToolsFormStep-back',
      objectId: 'goToolsFormStep',
      activeStep,
      inputName,
      inputType,
      pageId,
      pageSlug,
      totalSteps
    })
  }

  /**
   * Tracks when a user completes a step in the form, i.e. fills in user input fields and
   * clicks 'Continue'
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param inputMethod - Relevant to `inputType` long text or short text
   */
  goToolsFormStepComplete(
    activeStep: number,
    inputName: string,
    inputType: 'file upload' | 'long text' | 'short text',
    pageId: string,
    pageSlug: string,
    totalSteps: number,
    characterCount?: number,
    inputMethod?: 'paste' | 'type'
  ): Promise<void> {
    return this.gnar.track({
      action: 'complete',
      eventName: 'cms/goToolsFormStep-complete',
      objectId: 'goToolsFormStep',
      activeStep,
      inputName,
      inputType,
      pageId,
      pageSlug,
      totalSteps,
      characterCount,
      inputMethod
    })
  }

  /**
   * Tracks when a user submits the form.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsFormSubmit(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'submit',
      eventName: 'cms/goToolsForm-submit',
      objectId: 'goToolsForm',
      pageId,
      pageSlug
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsGenerateFailure(
    pageId: string,
    pageSlug: string,
    error?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'failure',
      eventName: 'cms/goToolsGenerate-failure',
      objectId: 'goToolsGenerate',
      pageId,
      pageSlug,
      error
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsGenerateLoading(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'loading',
      eventName: 'cms/goToolsGenerate-loading',
      objectId: 'goToolsGenerate',
      pageId,
      pageSlug
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsGenerateStillLoading(
    pageId: string,
    pageSlug: string,
    timeElapsed: number
  ): Promise<void> {
    return this.gnar.track({
      action: 'stillLoading',
      eventName: 'cms/goToolsGenerate-stillLoading',
      objectId: 'goToolsGenerate',
      pageId,
      pageSlug,
      timeElapsed
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsGenerateStreaming(
    pageId: string,
    pageSlug: string,
    timeElapsed: number
  ): Promise<void> {
    return this.gnar.track({
      action: 'streaming',
      eventName: 'cms/goToolsGenerate-streaming',
      objectId: 'goToolsGenerate',
      pageId,
      pageSlug,
      timeElapsed
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsGenerateSuccess(
    characterCount: number,
    pageId: string,
    pageSlug: string,
    timeElapsed: number
  ): Promise<void> {
    return this.gnar.track({
      action: 'success',
      eventName: 'cms/goToolsGenerate-success',
      objectId: 'goToolsGenerate',
      characterCount,
      pageId,
      pageSlug,
      timeElapsed
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsIntoolSignupWallShow(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/goToolsIntoolSignupWall-show',
      objectId: 'goToolsIntoolSignupWall',
      pageId,
      pageSlug
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsRadioSelect(
    pageId: string,
    pageSlug: string,
    promptType: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'select',
      eventName: 'cms/goToolsRadio-select',
      objectId: 'goToolsRadio',
      pageId,
      pageSlug,
      promptType
    })
  }

  /**
   * 
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  goToolsWallShow(
    pageId: string,
    pageSlug: string,
    wallType: 'signup' | 'upgrade' | 'premium'
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/goToolsWall-show',
      objectId: 'goToolsWall',
      pageId,
      pageSlug,
      wallType
    })
  }

  /**
   * Fires when user fails to authenticate with Google through One Tap
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  googleOneTapAuthFail(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'fail',
      eventName: 'cms/googleOneTapAuth-fail',
      object: 'googleOneTapAuth',
      pageId,
      pageSlug
    })
  }

  /**
   * Fires when user successfully authenticates with Google through One Tap
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  googleOneTapAuthSuccess(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'success',
      eventName: 'cms/googleOneTapAuth-success',
      object: 'googleOneTapAuth',
      pageId,
      pageSlug
    })
  }

  /**
   * Fires whenever there is a change in the state of the Google One Tap popup
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param reason - Complementary reason for a oneTapAction provided by Google
   */
  googleOneTapPopupChange(
    oneTapAction: 'DISPLAY_SUCCESS' | 'DISPLAY_FAIL' | 'SKIPPED' | 'DISMISSED',
    pageId: string,
    pageSlug: string,
    reason?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'Change',
      eventName: 'cms/googleOneTapPopup-Change',
      object: 'googleOneTapPopup',
      oneTapAction,
      pageId,
      pageSlug,
      reason
    })
  }

  /**
   * Fires when a message from the iframe is received, proxy for a successful form load. Base
   * event for iframe-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param srcUrl - Src URL
   * @param time - Time after page load that the event was received
   */
  iframeMessage(
    pageId: string,
    pageSlug: string,
    srcUrl: string,
    time?: number
  ): Promise<void> {
    return this.gnar.track({
      action: 'message',
      eventName: 'cms/iframe-message',
      object: 'iframe',
      pageId,
      pageSlug,
      srcUrl,
      time
    })
  }

  /**
   * Fires after a certain amount of time if no message is received from the iframe. Proxy for
   * an issue loading the iframe. Base event for iframe-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param srcUrl - Src URL
   * @param time - Time after page load in seconds.
   */
  iframeSlowLoad(
    pageId: string,
    pageSlug: string,
    srcUrl: string,
    time: number
  ): Promise<void> {
    return this.gnar.track({
      action: 'slowLoad',
      eventName: 'cms/iframe-slowLoad',
      object: 'iframe',
      pageId,
      pageSlug,
      srcUrl,
      time
    })
  }

  /**
   * Tracks clicks on Keyboard Install CTAs. Base events for button-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  installKeyboardButtonClick(
    pageId: string,
    pageSlug: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/installKeyboard-button-click',
      object: 'button',
      objectId: 'installKeyboard',
      pageId,
      pageSlug,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks clicks on Llama Install CTAs. Base events for button-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  installLlamaButtonClick(
    pageId: string,
    pageSlug: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/installLlama-button-click',
      object: 'button',
      objectId: 'installLlama',
      pageId,
      pageSlug,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks what option was selected in Variation Conditional Select component.
   * @param internalName - Internal name of the Variation Conditional Select Section in
   *                       Contentful
   * @param optionValue - Value of the option selected.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  itemDropdownVariationClick(
    internalName: string,
    optionValue: string,
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/item-dropdownVariation-click',
      object: 'dropdownVariation',
      objectId: 'item',
      internalName,
      optionValue,
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks clicks on linkable elements - like inline links, linkable cards, lists, etc Base
   * events for link-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param targetUrl - Target URL
   * @param label - Label associated with the link. For example, for the `Log
   *                in` link click, label will be "Log in".
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  linkClick(
    pageId: string,
    pageSlug: string,
    targetUrl: string,
    label?: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/link-click',
      object: 'link',
      pageId,
      pageSlug,
      targetUrl,
      label,
      placement,
      placementInternalName
    })
  }

  /**
   * Fires when a user is eligible for localized pricing experiment in India.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param variant - The localized pricing experiment variant
   */
  localizedPriceExperimentAnonTracked(
    pageId: string,
    pageSlug: string,
    variant: 'test_b' | 'test_c' | 'test_d' | 'control_a'
  ): Promise<void> {
    return this.gnar.track({
      action: 'tracked',
      eventName: 'cms/localizedPriceExperiment-anon-tracked',
      object: 'anon',
      objectId: 'localizedPriceExperiment',
      pageId,
      pageSlug,
      variant
    })
  }

  /**
   * 
   * @param interactionType - Describes user interaction type with the Qualified widget.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  messengerQualifiedInteraction(
    interactionType: 'Open' | 'Dismiss' | 'Close' | 'Conversation Started' | 'Meeting Booked' | 'Email Captured' | 'Other',
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'interaction',
      eventName: 'cms/messenger-qualified-interaction',
      object: 'qualified',
      objectId: 'messenger',
      interactionType,
      pageId,
      pageSlug
    })
  }

  /**
   * Fires when a cta within the modal is clicked. Base event for modal-related events
   * @param internalName - Modal internal name
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param actionType - Description of the action that was taken to help identify
   *                     action type.
   */
  modalClick(
    internalName: string,
    pageId: string,
    pageSlug: string,
    actionType?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/modal-click',
      object: 'modal',
      internalName,
      pageId,
      pageSlug,
      actionType
    })
  }

  /**
   * Fires when the modal is dismissed. Base event for modal-related events
   * @param internalName - Modal internal name
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  modalClose(
    internalName: string,
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'close',
      eventName: 'cms/modal-close',
      object: 'modal',
      internalName,
      pageId,
      pageSlug
    })
  }

  /**
   * Fires when the modal is shown. Base event for modal-related events
   * @param internalName - Modal internal name
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  modalShow(
    internalName: string,
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/modal-show',
      object: 'modal',
      internalName,
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks page performance INP event. Tracks page performance event. Base events for
   * page-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param referrer - Current page referrer
   * @param url - Full page url string
   * @param value - The value of the metric, like time for LCP or score for CLS.
   * @param eventTarget - A selector identifying the element that the user interacted
   *                      with for the event corresponding to INP.
   * @param eventTime - The time when the user interacted for the event
   *                    corresponding to INP.
   * @param eventType - The `type` of the `event` dispatched corresponding to INP.
   * @param loadState - The loading state of the document at the time when the event
   *                    corresponding to INP occurred (see `LoadState` for details).
   *                    If the interaction occurred while the document was loading
   *                    and executing script (e.g. usually in the `dom-interactive`
   *                    phase) it can result in long delays.
   */
  pagePerformanceInp(
    pageId: string,
    pageSlug: string,
    referrer: string,
    url: string,
    value: number,
    eventTarget?: string,
    eventTime?: number,
    eventType?: string,
    loadState?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'inp',
      eventName: 'cms/pagePerformance-inp',
      object: 'pagePerformance',
      pageId,
      pageSlug,
      referrer,
      url,
      value,
      eventTarget,
      eventTime,
      eventType,
      loadState
    })
  }

  /**
   * Tracks page visits event. Base events for page-related events
   * @param isStaticFallback - When true, indicates that the rendered page was a static
   *                           fallback.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param referrer - Current page referrer
   * @param url - Full page url string
   */
  pageShow(
    isStaticFallback: boolean,
    pageId: string,
    pageSlug: string,
    referrer: string,
    url: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/page-show',
      object: 'page',
      isStaticFallback,
      pageId,
      pageSlug,
      referrer,
      url
    })
  }

  /**
   * Tracks when the intool sign up walls shows within the Plagiarism Currently, it shows after
   * a user submits 1 time.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  plagiarismIntoolSignupWallShow(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/plagiarismIntoolSignupWall-show',
      objectId: 'plagiarismIntoolSignupWall',
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks clicks on the "Already have an account" login link in the plagiarism tool.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  plagiarismLoginLinkClick(
    pageId: string,
    pageSlug: string,
    placement: 'initialSide' | 'wallSide' | 'signupWall' | 'report'
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/plagiarismLoginLink-click',
      objectId: 'plagiarismLoginLink',
      pageId,
      pageSlug,
      placement
    })
  }

  /**
   * Tracks when the sign up dialog shows within the Plagiarism or Text Checker Report
   * component. Currently, it shows after a user submits 1 time.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  plagiarismWallShow(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/plagiarismWall-show',
      objectId: 'plagiarismWall',
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks clicks on the CTA in the report summary section.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  reportSummaryCtaLinkClick(
    ctaType: 'signup' | 'premium',
    pageId: string,
    pageSlug: string,
    placement: 'initialSide' | 'wallSide' | 'signupWall' | 'report'
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/reportSummaryCta-link-click',
      object: 'link',
      objectId: 'reportSummaryCta',
      ctaType,
      pageId,
      pageSlug,
      placement
    })
  }

  /**
   * Tracks clicks on navigation arrows in Section: Linkable Boxes components when scrollable
   * is enabled Base events for button-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  scrollableCardsNavButtonClick(
    navLabel: 'previous' | 'next',
    pageId: string,
    pageSlug: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/scrollableCardsNav-button-click',
      object: 'button',
      objectId: 'scrollableCardsNav',
      navLabel,
      pageId,
      pageSlug,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks when a user scrolls to section on the page. Only fires once per section per page
   * visit.
   * @param internalName - Internal name of the Section in Contentful
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  sectionScroll(
    internalName: string,
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'scroll',
      eventName: 'cms/section-scroll',
      object: 'section',
      internalName,
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks static fallback page show. Base events for page-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param referrer - Current page referrer
   * @param url - Full page url string
   */
  staticFallbackPageShow(
    pageId: string,
    pageSlug: string,
    referrer: string,
    url: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/staticFallback-page-show',
      object: 'page',
      objectId: 'staticFallback',
      pageId,
      pageSlug,
      referrer,
      url
    })
  }

  /**
   * Tracks clicks on tabs in Section: Tabs components Base events for button-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  tabButtonClick(
    pageId: string,
    pageSlug: string,
    tabIndex: number,
    tabLabel: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/tab-button-click',
      object: 'button',
      objectId: 'tab',
      pageId,
      pageSlug,
      tabIndex,
      tabLabel,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks when a user clicks the file upload button.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  toolFileUploadButtonClick(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/toolFileUploadButton-click',
      objectId: 'toolFileUploadButton',
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks when a user uploads a file fails.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  toolFileUploadFailure(
    errorType: string,
    pageId: string,
    pageSlug: string,
    fileSize?: number
  ): Promise<void> {
    return this.gnar.track({
      action: 'failure',
      eventName: 'cms/toolFileUpload-failure',
      objectId: 'toolFileUpload',
      errorType,
      pageId,
      pageSlug,
      fileSize
    })
  }

  /**
   * Tracks when a user uploads a file successfully.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  toolFileUploadSuccess(
    pageId: string,
    pageSlug: string,
    fileSize?: number,
    fileType?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'success',
      eventName: 'cms/toolFileUpload-success',
      objectId: 'toolFileUpload',
      pageId,
      pageSlug,
      fileSize,
      fileType
    })
  }

  /**
   * Tracks when a user clicks the sample text button.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  toolSampleTextClick(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/toolSampleText-click',
      objectId: 'toolSampleText',
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks when the text limit wall shows.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  toolTextLimitWallShow(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/toolTextLimitWall-show',
      objectId: 'toolTextLimitWall',
      pageId,
      pageSlug
    })
  }

  /**
   * Tracks when the usage wall shows.
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   */
  toolUsageWallShow(
    pageId: string,
    pageSlug: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/toolUsageWall-show',
      objectId: 'toolUsageWall',
      pageId,
      pageSlug
    })
  }

  /**
   * Fires when auth step form is shown. Check "formKey" prop for details on what form was
   * shown. Abstract event for auth form params
   * @param formKey - Tracks the shown auth form type
   * @param isGdpr - Indicates the GDPR version of the auth form
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param isExplicitTermsOfService - Indicates the version of the sign-up form with the explicit
   *                                   Terms of Service checkbox true -- for the sign-up form with
   *                                   the explicit Terms of Service checkbox false -- for the
   *                                   sign-up form with the implicit Terms of Service null -- for
   *                                   other pages
   * @param pageStyle - Tracks the page style of unified sign in.
   */
  unifiedAuthFormShow(
    formKey: 'SignInInit' | 'SignUpEmailVerification' | 'SignUpEmailVerificationByLink' | 'SignInWithPassword' | 'SecureSignIn' | 'NewAccount' | 'NewAccountMask' | 'SignUpEmailPermissionPopup' | 'SignInEmailPermissionPopup' | 'ExplicitTermsOfServicePopup' | 'OAuthConsent' | 'MFA' | 'Captcha' | 'ResetPassword' | 'ResetPasswordEmailSent' | 'VerifyResetKey' | 'SetNewPassword' | 'SetNewPasswordUpdated' | 'ForgotEmail' | 'SupportRequest' | 'SupportRequestSent' | 'GoogleOneTapSignUp' | 'SignUpStart' | 'ChooseAccount' | 'RemoveAccount' | 'RemoveAccountPopup' | 'SocialAccountLinking' | 'MfaSocialAccountLinking' | 'WelcomeBack' | 'ContinueSSO',
    isGdpr: boolean,
    pageId: string,
    pageSlug: string,
    isExplicitTermsOfService?: boolean,
    pageStyle?: 'main' | 'developer'
  ): Promise<void> {
    return this.gnar.track({
      action: 'show',
      eventName: 'cms/unifiedAuthForm-show',
      object: 'unifiedAuthForm',
      formKey,
      isGdpr,
      pageId,
      pageSlug,
      isExplicitTermsOfService,
      pageStyle
    })
  }

  /**
   * Fires when user clicks on the submit button (email, sso and social flows) on the sign-in
   * or sign-up. Use this error to identify user-initiated actions Abstract event for auth form
   * params Base unified Auth action event. Contains info about the expected action (SIGNIN or
   * SIGNUP) for the attempts and fails tracking and an actual action for the success tracking
   * @param authAction - Tracks an actual auth action
   * @param emailOptOut - Whether the GDPR user chooses to opt out of emails. For
   *                      non-GDPR user, it should be false. For GDPR-users, it should
   *                      default to true unless the user checks the "Send marketing
   *                      emails" checkbox.
   * @param flowType - Auth flow type
   * @param formKey - Tracks the shown auth form type
   * @param isGdpr - Indicates the GDPR version of the auth form
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened. Page ID field of the page from
   *                 Contentful Page entry on which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters. Url
   *                   path of the page on which event happened. It excludes the
   *                   leading and trailing slash and query parameters.
   * @param countSubmits - The number of times a user submitted while on the same form.
   * @param fieldErrors - Shows error occurred at form submit. Includes values: field
   *                      (shows in which form field error appeared), message (shows
   *                      error message).
   * @param hasSignUpEmailVerificationCode - Whether the user has provided an input to the sign-up email
   *                                         verification code form
   * @param isExplicitTermsOfService - Indicates the version of the sign-up form with the explicit
   *                                   Terms of Service checkbox true -- for the sign-up form with
   *                                   the explicit Terms of Service checkbox false -- for the
   *                                   sign-up form with the implicit Terms of Service null -- for
   *                                   other pages
   * @param isSecureSignIn - Determines if this action was fired during the secure
   *                         sign-in flow
   * @param isSignUpEmailVerificationResendCodeRequest - Whether the request was used to resend the email
   *                                                     verification code
   * @param mfaMode - Specifies which MFA mode the user is using to sign-in.
   * @param pageStyle - Tracks the page style of unified sign in.
   * @param socialType - Social provider type, has data only for the social flowType
   * @param termsOfServiceAccepted - Whether user accepted ToS. For the explicit ToS variation on
   *                                 the sign-up page should true or false (false indicates
   *                                 error). For the implicit ToS variation on the sign-up page
   *                                 is always true Null for all other pages
   * @param useSignUpEmailVerification - Whether the user is using sign-up email verification
   */
  unifiedAuthFormSubmitButtonClick(
    authAction: 'SIGNIN' | 'SIGNUP',
    emailOptOut: boolean,
    flowType: 'email' | 'social' | 'sso',
    formKey: 'SignInInit' | 'SignUpEmailVerification' | 'SignUpEmailVerificationByLink' | 'SignInWithPassword' | 'SecureSignIn' | 'NewAccount' | 'NewAccountMask' | 'SignUpEmailPermissionPopup' | 'SignInEmailPermissionPopup' | 'ExplicitTermsOfServicePopup' | 'OAuthConsent' | 'MFA' | 'Captcha' | 'ResetPassword' | 'ResetPasswordEmailSent' | 'VerifyResetKey' | 'SetNewPassword' | 'SetNewPasswordUpdated' | 'ForgotEmail' | 'SupportRequest' | 'SupportRequestSent' | 'GoogleOneTapSignUp' | 'SignUpStart' | 'ChooseAccount' | 'RemoveAccount' | 'RemoveAccountPopup' | 'SocialAccountLinking' | 'MfaSocialAccountLinking' | 'WelcomeBack' | 'ContinueSSO',
    isGdpr: boolean,
    pageId: string,
    pageSlug: string,
    countSubmits?: number,
    fieldErrors?: Array<{  }>,
    hasSignUpEmailVerificationCode?: boolean,
    isExplicitTermsOfService?: boolean,
    isSecureSignIn?: boolean,
    isSignUpEmailVerificationResendCodeRequest?: boolean,
    mfaMode?: 'sms' | 'totp' | 'backup' | 'email',
    pageStyle?: 'main' | 'developer',
    socialType?: 'Facebook' | 'Google' | 'Apple',
    termsOfServiceAccepted?: boolean,
    useSignUpEmailVerification?: boolean
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/unifiedAuthForm-submitButton-click',
      object: 'submitButton',
      objectId: 'unifiedAuthForm',
      authAction,
      emailOptOut,
      flowType,
      formKey,
      isGdpr,
      pageId,
      pageSlug,
      countSubmits,
      fieldErrors,
      hasSignUpEmailVerificationCode,
      isExplicitTermsOfService,
      isSecureSignIn,
      isSignUpEmailVerificationResendCodeRequest,
      mfaMode,
      pageStyle,
      socialType,
      termsOfServiceAccepted,
      useSignUpEmailVerification
    })
  }

  /**
   * Fires for the sign-in or sign-up auth requests attempt. Abstract event for Auth request
   * events including attempt, success, and fail Abstract event for auth form params Base
   * unified Auth action event. Contains info about the expected action (SIGNIN or SIGNUP) for
   * the attempts and fails tracking and an actual action for the success tracking
   * @param authAction - Tracks an actual auth action
   * @param emailOptOut - Whether the GDPR user chooses to opt out of emails. For
   *                      non-GDPR user, it should be false. For GDPR-users, it should
   *                      default to true unless the user checks the "Send marketing
   *                      emails" checkbox.
   * @param flowType - Auth flow type
   * @param formKey - Tracks the shown auth form type
   * @param isGdpr - Indicates the GDPR version of the auth form
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened. Page ID field of the page from
   *                 Contentful Page entry on which event happened. Page ID field
   *                 of the page from Contentful Page entry on which event
   *                 happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters. Url
   *                   path of the page on which event happened. It excludes the
   *                   leading and trailing slash and query parameters. Url path of
   *                   the page on which event happened. It excludes the leading
   *                   and trailing slash and query parameters.
   * @param hasSignUpEmailVerificationCode - Whether the user has provided an input to the sign-up email
   *                                         verification code form
   * @param initFlowFormKey - Tracks the auth form type which the flow started at. This is
   *                          especially useful for Social auth flow where a user may have
   *                          started the flow in one form, redirected to Social provider,
   *                          and then continued the flow in another form.
   * @param isExplicitTermsOfService - Indicates the version of the sign-up form with the explicit
   *                                   Terms of Service checkbox true -- for the sign-up form with
   *                                   the explicit Terms of Service checkbox false -- for the
   *                                   sign-up form with the implicit Terms of Service null -- for
   *                                   other pages
   * @param isSecureSignIn - Determines if this action was fired during the secure
   *                         sign-in flow
   * @param isSignUpEmailVerificationResendCodeRequest - Whether the request was used to resend the email
   *                                                     verification code
   * @param mfaMode - Specifies which MFA mode the user is using to sign-in.
   * @param pageStyle - Tracks the page style of unified sign in.
   * @param socialType - Social provider type, has data only for the social flowType
   * @param termsOfServiceAccepted - Whether user accepted ToS. For the explicit ToS variation on
   *                                 the sign-up page should true or false (false indicates
   *                                 error). For the implicit ToS variation on the sign-up page
   *                                 is always true Null for all other pages
   * @param useSignUpEmailVerification - Whether the user is using sign-up email verification
   */
  unifiedAuthRequestAttempt(
    authAction: 'SIGNIN' | 'SIGNUP',
    emailOptOut: boolean,
    flowType: 'email' | 'social' | 'sso',
    formKey: 'SignInInit' | 'SignUpEmailVerification' | 'SignUpEmailVerificationByLink' | 'SignInWithPassword' | 'SecureSignIn' | 'NewAccount' | 'NewAccountMask' | 'SignUpEmailPermissionPopup' | 'SignInEmailPermissionPopup' | 'ExplicitTermsOfServicePopup' | 'OAuthConsent' | 'MFA' | 'Captcha' | 'ResetPassword' | 'ResetPasswordEmailSent' | 'VerifyResetKey' | 'SetNewPassword' | 'SetNewPasswordUpdated' | 'ForgotEmail' | 'SupportRequest' | 'SupportRequestSent' | 'GoogleOneTapSignUp' | 'SignUpStart' | 'ChooseAccount' | 'RemoveAccount' | 'RemoveAccountPopup' | 'SocialAccountLinking' | 'MfaSocialAccountLinking' | 'WelcomeBack' | 'ContinueSSO',
    isGdpr: boolean,
    pageId: string,
    pageSlug: string,
    hasSignUpEmailVerificationCode?: boolean,
    initFlowFormKey?: 'SignInInit' | 'SignUpEmailVerification' | 'SignUpEmailVerificationByLink' | 'SignInWithPassword' | 'SecureSignIn' | 'NewAccount' | 'NewAccountMask' | 'SignUpEmailPermissionPopup' | 'SignInEmailPermissionPopup' | 'ExplicitTermsOfServicePopup' | 'OAuthConsent' | 'MFA' | 'Captcha' | 'ResetPassword' | 'ResetPasswordEmailSent' | 'VerifyResetKey' | 'SetNewPassword' | 'SetNewPasswordUpdated' | 'ForgotEmail' | 'SupportRequest' | 'SupportRequestSent' | 'GoogleOneTapSignUp' | 'SignUpStart' | 'ChooseAccount' | 'RemoveAccount' | 'RemoveAccountPopup' | 'SocialAccountLinking' | 'MfaSocialAccountLinking' | 'WelcomeBack' | 'ContinueSSO',
    isExplicitTermsOfService?: boolean,
    isSecureSignIn?: boolean,
    isSignUpEmailVerificationResendCodeRequest?: boolean,
    mfaMode?: 'sms' | 'totp' | 'backup' | 'email',
    pageStyle?: 'main' | 'developer',
    socialType?: 'Facebook' | 'Google' | 'Apple',
    termsOfServiceAccepted?: boolean,
    useSignUpEmailVerification?: boolean
  ): Promise<void> {
    return this.gnar.track({
      action: 'attempt',
      eventName: 'cms/unifiedAuthRequest-attempt',
      object: 'unifiedAuthRequest',
      authAction,
      emailOptOut,
      flowType,
      formKey,
      isGdpr,
      pageId,
      pageSlug,
      hasSignUpEmailVerificationCode,
      initFlowFormKey,
      isExplicitTermsOfService,
      isSecureSignIn,
      isSignUpEmailVerificationResendCodeRequest,
      mfaMode,
      pageStyle,
      socialType,
      termsOfServiceAccepted,
      useSignUpEmailVerification
    })
  }

  /**
   * Fires for the failed sign-in or sign-up auth requests. Some errors can be recoverable (for
   * example, SHOW_MFA error indicates successful initial sign-in step, but the flow requires
   * additional steps). For those errors check `isRecoverable` prop Abstract event for auth
   * error code params Abstract event for Auth request events including attempt, success, and
   * fail Abstract event for auth form params Base unified Auth action event. Contains info
   * about the expected action (SIGNIN or SIGNUP) for the attempts and fails tracking and an
   * actual action for the success tracking
   * @param authAction - Tracks an actual auth action
   * @param emailOptOut - Whether the GDPR user chooses to opt out of emails. For
   *                      non-GDPR user, it should be false. For GDPR-users, it should
   *                      default to true unless the user checks the "Send marketing
   *                      emails" checkbox.
   * @param errorCode - Contains the error code
   * @param flowType - Auth flow type
   * @param formKey - Tracks the shown auth form type
   * @param isGdpr - Indicates the GDPR version of the auth form
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened. Page ID field of the page from
   *                 Contentful Page entry on which event happened. Page ID field
   *                 of the page from Contentful Page entry on which event
   *                 happened. Page ID field of the page from Contentful Page
   *                 entry on which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters. Url
   *                   path of the page on which event happened. It excludes the
   *                   leading and trailing slash and query parameters. Url path of
   *                   the page on which event happened. It excludes the leading
   *                   and trailing slash and query parameters. Url path of the
   *                   page on which event happened. It excludes the leading and
   *                   trailing slash and query parameters.
   * @param hasSignUpEmailVerificationCode - Whether the user has provided an input to the sign-up email
   *                                         verification code form
   * @param initFlowFormKey - Tracks the auth form type which the flow started at. This is
   *                          especially useful for Social auth flow where a user may have
   *                          started the flow in one form, redirected to Social provider,
   *                          and then continued the flow in another form.
   * @param isExplicitTermsOfService - Indicates the version of the sign-up form with the explicit
   *                                   Terms of Service checkbox true -- for the sign-up form with
   *                                   the explicit Terms of Service checkbox false -- for the
   *                                   sign-up form with the implicit Terms of Service null -- for
   *                                   other pages
   * @param isRecoverable - Indicates the recoverable error. Recoverable error means,
   *                        that the flow can continue, but it required additional steps
   * @param isSecureSignIn - Determines if this action was fired during the secure
   *                         sign-in flow
   * @param isSignUpEmailVerificationResendCodeRequest - Whether the request was used to resend the email
   *                                                     verification code
   * @param mfaMode - Specifies which MFA mode the user is using to sign-in.
   * @param pageStyle - Tracks the page style of unified sign in.
   * @param socialType - Social provider type, has data only for the social flowType
   * @param termsOfServiceAccepted - Whether user accepted ToS. For the explicit ToS variation on
   *                                 the sign-up page should true or false (false indicates
   *                                 error). For the implicit ToS variation on the sign-up page
   *                                 is always true Null for all other pages
   * @param useSignUpEmailVerification - Whether the user is using sign-up email verification
   */
  unifiedAuthRequestFailure(
    authAction: 'SIGNIN' | 'SIGNUP',
    emailOptOut: boolean,
    errorCode: 'UI_INVALID_REDIRECT_URI' | 'UI_MISSING_CLIENT_ID' | 'UI_MISSING_CODE_CHALLENGE' | 'UI_MISSING_SCOPES' | 'UI_INVALID_SCOPES' | 'UI_MISSING_REDIRECT_URI' | 'UI_INVALID_RESPONSE_MODE' | 'UI_STATE_MISMATCH' | 'UI_POST_MESSAGE_OPENER_DNE' | 'UI_NOT_IMPLEMENTED' | 'INVALID_CLIENT' | 'CANNOT_UPDATE_DATABASE' | 'MISSING_PARAMETER_ERROR' | 'INVALID_CLIENT_TYPE' | 'INVALID_ORIGIN' | 'INVALID_REDIRECT_URI' | 'INVALID_SCOPE' | 'OAUTH_NOT_ENABLED' | 'UNABLE_TO_GENERATE_TOKEN' | 'NOT_IMPLEMENTED' | 'VALIDATION_ERROR' | 'USER_NOT_AUTHORIZED' | 'INVALID_GRANT_TYPE' | 'FAILURE' | 'RATE_LIMITED' | 'SOCIAL_VERIFICATION' | 'SOCIAL_VERIFICATION_CODE' | 'EMAIL_VERIFICATION' | 'EMAIL_VERIFICATION_CODE' | 'REQUIRED_FIELDS' | 'USE_FB_LOGIN' | 'USE_GOOGLE_LOGIN' | 'USE_APPLE_LOGIN' | 'USE_SOCIAL_LOGIN' | 'USE_EMAIL_LOGIN' | 'USE_SSO_LOGIN' | 'ACCOUNT_EXISTS_WITH_DIFFERENT_LOGIN' | 'USE_STRONG_PASSWORD' | 'SHOW_MFA' | 'SOCIAL_MFA_VERIFICATION' | 'SHOW_CAPTCHA' | 'PASSWORD_REUSED' | 'EMAIL_EMPTY' | 'ALREADY_CONFIRMED' | 'INTERNAL_RUNTIME_ERROR' | 'INVALID_OAUTH_CODE' | 'EXPLICIT_SIGNUP_REQUIRED' | 'API_UNKNOWN' | 'UI_UNKNOWN' | 'UI_ACCEPT_TERMS_OF_SERVICE',
    flowType: 'email' | 'social' | 'sso',
    formKey: 'SignInInit' | 'SignUpEmailVerification' | 'SignUpEmailVerificationByLink' | 'SignInWithPassword' | 'SecureSignIn' | 'NewAccount' | 'NewAccountMask' | 'SignUpEmailPermissionPopup' | 'SignInEmailPermissionPopup' | 'ExplicitTermsOfServicePopup' | 'OAuthConsent' | 'MFA' | 'Captcha' | 'ResetPassword' | 'ResetPasswordEmailSent' | 'VerifyResetKey' | 'SetNewPassword' | 'SetNewPasswordUpdated' | 'ForgotEmail' | 'SupportRequest' | 'SupportRequestSent' | 'GoogleOneTapSignUp' | 'SignUpStart' | 'ChooseAccount' | 'RemoveAccount' | 'RemoveAccountPopup' | 'SocialAccountLinking' | 'MfaSocialAccountLinking' | 'WelcomeBack' | 'ContinueSSO',
    isGdpr: boolean,
    pageId: string,
    pageSlug: string,
    hasSignUpEmailVerificationCode?: boolean,
    initFlowFormKey?: 'SignInInit' | 'SignUpEmailVerification' | 'SignUpEmailVerificationByLink' | 'SignInWithPassword' | 'SecureSignIn' | 'NewAccount' | 'NewAccountMask' | 'SignUpEmailPermissionPopup' | 'SignInEmailPermissionPopup' | 'ExplicitTermsOfServicePopup' | 'OAuthConsent' | 'MFA' | 'Captcha' | 'ResetPassword' | 'ResetPasswordEmailSent' | 'VerifyResetKey' | 'SetNewPassword' | 'SetNewPasswordUpdated' | 'ForgotEmail' | 'SupportRequest' | 'SupportRequestSent' | 'GoogleOneTapSignUp' | 'SignUpStart' | 'ChooseAccount' | 'RemoveAccount' | 'RemoveAccountPopup' | 'SocialAccountLinking' | 'MfaSocialAccountLinking' | 'WelcomeBack' | 'ContinueSSO',
    isExplicitTermsOfService?: boolean,
    isRecoverable?: boolean,
    isSecureSignIn?: boolean,
    isSignUpEmailVerificationResendCodeRequest?: boolean,
    mfaMode?: 'sms' | 'totp' | 'backup' | 'email',
    pageStyle?: 'main' | 'developer',
    socialType?: 'Facebook' | 'Google' | 'Apple',
    termsOfServiceAccepted?: boolean,
    useSignUpEmailVerification?: boolean
  ): Promise<void> {
    return this.gnar.track({
      action: 'failure',
      eventName: 'cms/unifiedAuthRequest-failure',
      object: 'unifiedAuthRequest',
      authAction,
      emailOptOut,
      errorCode,
      flowType,
      formKey,
      isGdpr,
      pageId,
      pageSlug,
      hasSignUpEmailVerificationCode,
      initFlowFormKey,
      isExplicitTermsOfService,
      isRecoverable,
      isSecureSignIn,
      isSignUpEmailVerificationResendCodeRequest,
      mfaMode,
      pageStyle,
      socialType,
      termsOfServiceAccepted,
      useSignUpEmailVerification
    })
  }

  /**
   * Fires for the successful sign-in or sign-up auth requests. Abstract event for Auth request
   * events including attempt, success, and fail Abstract event for auth form params Base
   * unified Auth action event. Contains info about the expected action (SIGNIN or SIGNUP) for
   * the attempts and fails tracking and an actual action for the success tracking
   * @param authAction - Tracks an actual auth action
   * @param emailOptOut - Whether the GDPR user chooses to opt out of emails. For
   *                      non-GDPR user, it should be false. For GDPR-users, it should
   *                      default to true unless the user checks the "Send marketing
   *                      emails" checkbox.
   * @param flowType - Auth flow type
   * @param formKey - Tracks the shown auth form type
   * @param isGdpr - Indicates the GDPR version of the auth form
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened. Page ID field of the page from
   *                 Contentful Page entry on which event happened. Page ID field
   *                 of the page from Contentful Page entry on which event
   *                 happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters. Url
   *                   path of the page on which event happened. It excludes the
   *                   leading and trailing slash and query parameters. Url path of
   *                   the page on which event happened. It excludes the leading
   *                   and trailing slash and query parameters.
   * @param hasSignUpEmailVerificationCode - Whether the user has provided an input to the sign-up email
   *                                         verification code form
   * @param initFlowFormKey - Tracks the auth form type which the flow started at. This is
   *                          especially useful for Social auth flow where a user may have
   *                          started the flow in one form, redirected to Social provider,
   *                          and then continued the flow in another form.
   * @param isExplicitTermsOfService - Indicates the version of the sign-up form with the explicit
   *                                   Terms of Service checkbox true -- for the sign-up form with
   *                                   the explicit Terms of Service checkbox false -- for the
   *                                   sign-up form with the implicit Terms of Service null -- for
   *                                   other pages
   * @param isSecureSignIn - Determines if this action was fired during the secure
   *                         sign-in flow
   * @param isSignUpEmailVerificationResendCodeRequest - Whether the request was used to resend the email
   *                                                     verification code
   * @param mfaMode - Specifies which MFA mode the user is using to sign-in.
   * @param pageStyle - Tracks the page style of unified sign in.
   * @param socialType - Social provider type, has data only for the social flowType
   * @param termsOfServiceAccepted - Whether user accepted ToS. For the explicit ToS variation on
   *                                 the sign-up page should true or false (false indicates
   *                                 error). For the implicit ToS variation on the sign-up page
   *                                 is always true Null for all other pages
   * @param useSignUpEmailVerification - Whether the user is using sign-up email verification
   */
  unifiedAuthRequestSuccess(
    authAction: 'SIGNIN' | 'SIGNUP',
    emailOptOut: boolean,
    flowType: 'email' | 'social' | 'sso',
    formKey: 'SignInInit' | 'SignUpEmailVerification' | 'SignUpEmailVerificationByLink' | 'SignInWithPassword' | 'SecureSignIn' | 'NewAccount' | 'NewAccountMask' | 'SignUpEmailPermissionPopup' | 'SignInEmailPermissionPopup' | 'ExplicitTermsOfServicePopup' | 'OAuthConsent' | 'MFA' | 'Captcha' | 'ResetPassword' | 'ResetPasswordEmailSent' | 'VerifyResetKey' | 'SetNewPassword' | 'SetNewPasswordUpdated' | 'ForgotEmail' | 'SupportRequest' | 'SupportRequestSent' | 'GoogleOneTapSignUp' | 'SignUpStart' | 'ChooseAccount' | 'RemoveAccount' | 'RemoveAccountPopup' | 'SocialAccountLinking' | 'MfaSocialAccountLinking' | 'WelcomeBack' | 'ContinueSSO',
    isGdpr: boolean,
    pageId: string,
    pageSlug: string,
    hasSignUpEmailVerificationCode?: boolean,
    initFlowFormKey?: 'SignInInit' | 'SignUpEmailVerification' | 'SignUpEmailVerificationByLink' | 'SignInWithPassword' | 'SecureSignIn' | 'NewAccount' | 'NewAccountMask' | 'SignUpEmailPermissionPopup' | 'SignInEmailPermissionPopup' | 'ExplicitTermsOfServicePopup' | 'OAuthConsent' | 'MFA' | 'Captcha' | 'ResetPassword' | 'ResetPasswordEmailSent' | 'VerifyResetKey' | 'SetNewPassword' | 'SetNewPasswordUpdated' | 'ForgotEmail' | 'SupportRequest' | 'SupportRequestSent' | 'GoogleOneTapSignUp' | 'SignUpStart' | 'ChooseAccount' | 'RemoveAccount' | 'RemoveAccountPopup' | 'SocialAccountLinking' | 'MfaSocialAccountLinking' | 'WelcomeBack' | 'ContinueSSO',
    isExplicitTermsOfService?: boolean,
    isSecureSignIn?: boolean,
    isSignUpEmailVerificationResendCodeRequest?: boolean,
    mfaMode?: 'sms' | 'totp' | 'backup' | 'email',
    pageStyle?: 'main' | 'developer',
    socialType?: 'Facebook' | 'Google' | 'Apple',
    termsOfServiceAccepted?: boolean,
    useSignUpEmailVerification?: boolean
  ): Promise<void> {
    return this.gnar.track({
      action: 'success',
      eventName: 'cms/unifiedAuthRequest-success',
      object: 'unifiedAuthRequest',
      authAction,
      emailOptOut,
      flowType,
      formKey,
      isGdpr,
      pageId,
      pageSlug,
      hasSignUpEmailVerificationCode,
      initFlowFormKey,
      isExplicitTermsOfService,
      isSecureSignIn,
      isSignUpEmailVerificationResendCodeRequest,
      mfaMode,
      pageStyle,
      socialType,
      termsOfServiceAccepted,
      useSignUpEmailVerification
    })
  }

  /**
   * Click on 'Customer Business Agreement', 'Terms of Service', 'Privacy Policy', or 'CA
   * Privacy Policy' when a user creates a new account
   * @param disclosureType - Link type. It can be 'Customer Business Agreement', 'Terms
   *                         of Service', 'Privacy Policy', or 'CA Privacy Policy'
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param isGdpr - Indicates the GDPR version of the signup form true for the
   *                 GDPR version on the signup page false for the non-GDPR
   *                 version on the signup page null otherwise
   */
  unifiedAuthTosLinkClick(
    disclosureType: 'businessAgreement' | 'terms' | 'privacyPolicy' | 'CAPrivacyNotice',
    pageId: string,
    pageSlug: string,
    isGdpr?: boolean
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/unifiedAuthTosLink-click',
      object: 'unifiedAuthTosLink',
      disclosureType,
      pageId,
      pageSlug,
      isGdpr
    })
  }

  /**
   * Tracks clicks on upload file CTA on text checker component Base events for button-related
   * events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  uploadFileForTextCheckButtonClick(
    pageId: string,
    pageSlug: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/uploadFileForTextCheck-button-click',
      object: 'button',
      objectId: 'uploadFileForTextCheck',
      pageId,
      pageSlug,
      placement,
      placementInternalName
    })
  }

  /**
   * Tracks clicks on the watch full video button on embedded YouTube videos Base events for
   * button-related events
   * @param pageId - Page ID field of the page from Contentful Page entry on
   *                 which event happened.
   * @param pageSlug - Url path of the page on which event happened. It excludes
   *                   the leading and trailing slash and query parameters.
   * @param videoInternalName - Internal name of the video asset in Contentful
   * @param placement - Component the button is in, i.e. 'Header' or 'Section'
   * @param placementInternalName - Equates to the 'Internal Name' of the component from
   *                                Contentful the button is in. For example, if the button is
   *                                in a Section, this equals the 'Internal Name' of the
   *                                Section.
   */
  watchFullVideoButtonClickButtonClick(
    pageId: string,
    pageSlug: string,
    videoInternalName: string,
    placement?: 'Header' | 'Section' | 'Modal',
    placementInternalName?: string
  ): Promise<void> {
    return this.gnar.track({
      action: 'click',
      eventName: 'cms/watchFullVideoButtonClick-button-click',
      object: 'button',
      objectId: 'watchFullVideoButtonClick',
      pageId,
      pageSlug,
      videoInternalName,
      placement,
      placementInternalName
    })
  }
}
/* eslint-enable */
/* tslint:enable */
